import { type Item } from 'src/types'

export const items: Item[] = [
  {
    effects: {},
    createdAt: 1681750515216,
    id: 'bottle',
    price: 1,
    weight: 0,
    type: 'misc',
    isVerified: false
  },
  {
    effects: {
      counters: {
        player_dex: {
          '+': '6'
        },
        player_str: {
          '+': '4'
        }
      }
    },
    createdAt: 1681801833809,
    slot: 'hands',
    price: 300,
    id: 'scimitar',
    weight: 3,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      counters: {
        player_hp: {
          '+': 1
        }
      },
      items: {
        bottle: {
          '+': 1
        }
      }
    },
    createdAt: 1681750547786,
    id: 'smoothie',
    price: 5,
    weight: 0.5,
    type: 'use',
    isVerified: false
  },
  {
    effects: {
      counters: {
        kg_max: {
          '+': '10'
        }
      }
    },
    createdAt: 1681753494492,
    slot: 'feet',
    price: 150,
    id: 'leather boots',
    weight: 3,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      counters: {
        player_vit: {
          '+': '3'
        }
      }
    },
    createdAt: 1681801949800,
    slot: 'chest',
    price: 80,
    id: 'bear pelt',
    weight: 15,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      variables: {
        player_title: 'forsaken one'
      },
      location: 'eden',
      counters: {
        wrath_of_god: {
          '+': 1
        }
      },
      fight: 'snake_lvl_1'
    },
    createdAt: 1681750578021,
    id: 'apple of deceit',
    price: 0,
    weight: 0.2,
    type: 'use',
    isVerified: true
  },
  {
    effects: {
      counters: {
        player_vit: {
          '+': '1'
        }
      }
    },
    createdAt: 1681753346349,
    slot: 'chest',
    price: 100,
    id: 'jacket',
    weight: 2,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      counters: {
        player_dex: {
          '+': '4'
        },
        player_str: {
          '+': '4'
        }
      }
    },
    createdAt: 1681801764172,
    slot: 'hands',
    price: 400,
    id: 'rifle',
    weight: 15,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      counters: {
        player_vit: {
          '+': '3'
        }
      }
    },
    createdAt: 1683400698436,
    slot: 'head',
    price: 30,
    id: 'stone helmet',
    weight: 8,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {},
    createdAt: 1683488101232,
    price: 1,
    id: 'cigs',
    weight: 0,
    isVerified: false,
    type: 'misc'
  },
  {
    effects: {},
    createdAt: 1681750596558,
    id: 'fluff',
    price: 1,
    weight: 0,
    type: 'misc',
    isVerified: true
  },
  {
    effects: {
      counters: {
        player_dex: {
          '+': 1
        },
        player_str: {
          '+': 1
        }
      },
      variables: {
        player_attack_log: 'You stabbed your enemy.'
      }
    },
    createdAt: 1681750657651,
    slot: 'hands',
    id: 'knife',
    price: 10,
    weight: 1,
    type: 'equip',
    isVerified: false
  },
  {
    effects: {
      counters: {
        light_radius: {
          '+': '3'
        }
      }
    },
    createdAt: 1681753681474,
    slot: 'head',
    price: 10,
    id: 'headlamp',
    weight: 0.2,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {},
    createdAt: 1681753569414,
    slot: 'hands',
    price: 10,
    id: 'torch',
    weight: 2,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      switches: {
        player_skill_stun: true
      },
      counters: {
        player_strength: {
          '+': 2
        }
      },
      variables: {
        player_attack_log: 'You pummelled your enemy with your hammer'
      }
    },
    createdAt: 1681750683195,
    slot: 'hands',
    id: 'hammer',
    price: 20,
    weight: 2,
    type: 'equip',
    isVerified: false
  },
  {
    effects: {
      counters: {
        bag_slots: {
          '+': '8'
        },
        player_dex: {
          '-': 1
        },
        kg_max: {
          '+': '20'
        }
      }
    },
    createdAt: 1681750020036,
    slot: 'bag',
    price: 50,
    id: 'backpack',
    weight: 1,
    isVerified: false,
    type: 'equip'
  },
  {
    effects: {
      counters: {
        player_hp: {
          '+': 1
        }
      },
      items: {
        bottle: {
          '+': 1
        }
      }
    },
    createdAt: 1681750711974,
    id: 'orange juice',
    price: 2,
    weight: 0.5,
    type: 'use',
    isVerified: false
  },
  {
    effects: {},
    createdAt: 1681750729042,
    id: 'fur',
    price: 10,
    weight: 5,
    type: 'misc',
    isVerified: false
  }
]


// Export removed - now using named export above
